/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { MyTasksTable } from './MyTasksTable'
import { TaskStatus } from '../../../../constants/task'

interface MyTasksSectionProps {
  isEosEnabled: boolean
}

export const MyTasksSection: React.FC<MyTasksSectionProps> = ({ isEosEnabled }) => {
  const {
    service: {
      filter: { translate }
    },
    api,
    service: { auth }
  } = useServiceContext()

  const loadDataMyTasks = (
    pagingParams: any,
    filter?: any
  ): Promise<{
    elements: any[]
    totalElements: number
    hasNextPage?: boolean
  }> => {
    return new Promise((resolve, reject) => {
      const defaultFilter = {
        sortBy: pagingParams?.sortBy || 'START_DATE',
        sortDesc: pagingParams?.sortDesc !== undefined ? pagingParams.sortDesc : true,
        taskStatus: TaskStatus.OPEN as 'OPEN',
        pageSize: 5,
        pageStart: 0,
        userId: auth.getUser()?.id || 1457 // Provide fallback user ID
      }

      // Apply any additional filters if provided
      if (filter && Object.keys(filter).length > 0) {
        Object.assign(defaultFilter, filter)
      }

      if (isEosEnabled && pagingParams) {
        console.log('EOS enabled, using paging params:', pagingParams)
      }

      // Make API call with better error handling
      api.tasks
        .getTasksList(defaultFilter)
        .then(function (response: any) {
          if (response?.elements?.length > 0) {
            resolve({
              elements: response.elements,
              totalElements: response.totalElements,
              hasNextPage: response.hasNextPage || false
            })
          } else {
            console.log('API returned empty data, falling back to mock')
            // Fall through to mock data
            throw new Error('Empty API response')
          }
        })
        .catch((error) => {
          console.log('❌ API FAILED or returned empty data')
          console.log('Error details:', error)
          console.log('Using mock data...')

          resolve({
            elements: [],
            totalElements: 0,
            hasNextPage: false
          })
        })
    })
  }

  return (
    <>
      <h2 className="tasks">{translate('MY_TASKS')}</h2>
      <RcmTableDataWrapper
        persistenceKey="dashboardMyTasks"
        defaultSortBy="START_DATE"
        defaultSortDesc={true}
        loadData={loadDataMyTasks}
      >
        <MyTasksTable isEosEnabled={isEosEnabled} />
      </RcmTableDataWrapper>
    </>
  )
}
